import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectActiveMeetingHasAccessToChat,
    selectEphemeralChatUnavailable,
    selectNumberOfUnreadMessages,
} from 'flow/selectors/meeting-selectors';
import { selectVideoChatUnreadExternalCount } from 'flow/selectors/video-chat-selectors';

/**
 * Shared meeting chat availability state for the footer's chat entry
 * points (button, more-menu item, sidebar overflow item).
 */
const useMeetingChatState = () => {
    const hasAccessToMeetingChat = useAppSelector(
        selectActiveMeetingHasAccessToChat,
    );
    const ephemeralChatUnavailable = useAppSelector(
        selectEphemeralChatUnavailable,
    );
    const numberOfUnreadMessages = useAppSelector(selectNumberOfUnreadMessages);
    // Guest-relay unread count, added on top (VID-433).
    const unreadExternalCount = useAppSelector(
        selectVideoChatUnreadExternalCount,
    );

    return {
        chatDisabled: !hasAccessToMeetingChat || ephemeralChatUnavailable,
        numberOfUnreadMessages: numberOfUnreadMessages + unreadExternalCount,
    };
};

export default useMeetingChatState;
